import type { FC } from 'react';
import { logger } from '../utils/logger';
import type { AdMeshLayoutProps } from '../types/index';
import { AdMeshCompactCard } from './AdMeshCompactCard';

export const AdMeshLayout: FC<AdMeshLayoutProps> = ({
  recommendations,
  theme,
  className,
  style,
  sessionId,
  onDelegationConsent,
  onDelegationActivated,
  onStartDelegation,
}) => {
  const validRecs = recommendations.filter(
    (rec) => rec && typeof rec === 'object' && typeof rec.recommendation_id === 'string' && rec.recommendation_id.length > 0,
  );

  // Validate that valid recommendations are provided
  if (!validRecs || validRecs.length === 0) {
    logger.log('[AdMeshLayout] Empty or invalid recommendations array - not rendering anything');
    return null;
  }

  logger.log(`[AdMeshLayout] Rendering with ${validRecs.length} valid recommendations`);

  // Render based on layout type (default to tail)
  const renderContent = () => {
    if (validRecs.length > 0) {
      const firstRec = validRecs[0];
      const preferredFormat = firstRec.recommendation?.format;
      
      logger.log('[AdMeshLayout] 🔍 Checking format:', {
        preferredFormat,
        recommendationKeys: Object.keys(firstRec || {})
      });

      if (preferredFormat === 'product_card' || preferredFormat === 'weave' || preferredFormat === 'bridge') {
        logger.warn(`[AdMeshLayout] ${preferredFormat} format requested, falling back to tail for canonical render payload`);
      }
    }

    return (
      <AdMeshCompactCard
        recommendations={validRecs}
        theme={theme}
        sessionId={sessionId}
        onDelegationConsent={onDelegationConsent}
        onDelegationActivated={onDelegationActivated}
        onStartDelegation={onStartDelegation}
      />
    );
  };

  return (
    <div
      className={`admesh-layout ${className}`}
      style={{
        fontFamily: theme?.fontFamily || '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        ...style
      }}
    >
      {renderContent()}
    </div>
  );
};

export default AdMeshLayout;
